/**
 * Event fired when user clicks on the dislike button.
 */
var dislikeButtonClicked = function dislikeButtonClicked() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$jsEvent = _ref.jsEvent,
      jsEvent = _ref$jsEvent === void 0 ? {} : _ref$jsEvent;

  return {
    type: 'dislike-clicked',
    payload: {
      isSelected: isSelected,
      jsEvent: jsEvent
    }
  };
};
/**
 * Event fired when user clicks on the like button.
 */


var likeButtonClicked = function likeButtonClicked() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$isSelected = _ref2.isSelected,
      isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected,
      _ref2$jsEvent = _ref2.jsEvent,
      jsEvent = _ref2$jsEvent === void 0 ? {} : _ref2$jsEvent;

  return {
    type: 'like-clicked',
    payload: {
      isSelected: isSelected,
      jsEvent: jsEvent
    }
  };
};

export { dislikeButtonClicked, likeButtonClicked };